import React from 'react';
import { useIntl } from 'react-intl';
import { StyledModalHeader } from '@whitelabel/component-library';
import { ReactComponent as IconReturn } from '@whitelabel/media/icons/small/chevron-left.svg';
import { SKYSCANNER_PARTNER_ID } from '@whitelabel/xcover-shared/helpers/constants';
import { IHelpPagePartner } from '@whitelabel/xcover-shared/helpers/types';
import { StyledPartnerHeader, StyledPartnerInfo } from '@whitelabel/xcover-shared/styled/StyledPartnerHeader';
import contactModalMsg from '@whitelabel/xcover-shared/helpers/messages/contactModalMsg';

interface IPartnerHeaderProps {
  toggleModalClose: () => void;
  partner?: IHelpPagePartner;
  returnPreviousStep: () => void;
  enableReturn?: boolean;
}

const PartnerHeader = ({
  partner,
  enableReturn = false,
  toggleModalClose,
  returnPreviousStep,
}: IPartnerHeaderProps): JSX.Element => {
  const { formatMessage } = useIntl();
  return (
    <StyledPartnerHeader>
      <StyledModalHeader tag="h1" toggle={toggleModalClose}>
        {enableReturn && (
          <button className="btn-return" type="button" aria-label="return" onClick={returnPreviousStep}>
            <IconReturn />
          </button>
        )}
        {formatMessage(contactModalMsg.protectionTitle)}
      </StyledModalHeader>
      {partner && (
        <StyledPartnerInfo>
          {/* business requirement: don't show skyscanner logo */}
          {partner.logo && partner.id !== SKYSCANNER_PARTNER_ID && (
            <div className="image-wrapper">
              <img src={partner.logo} alt={partner.slug} className="image-box-image" />
            </div>
          )}
          <h2>{formatMessage(contactModalMsg.protectionText, { partnerName: partner.title })}</h2>
        </StyledPartnerInfo>
      )}
    </StyledPartnerHeader>
  );
};

export default PartnerHeader;
